import DeliveryService from "../DeliveryService"

const Order = {
    formData(data) {
        let form = new FormData()
        for (let obj in data) {
            form.append(obj, data[obj])
        }
        return form
    },
    gets(r) {
        let url = '/console/orders'
        if (r != undefined) {
            url = '/console/orders?' + r
        }
        return DeliveryService.get(url)
    },
    search(params) {
        var queryString = Object.keys(params)
        .map(key => key + "=" + params[key])
        .join("&");
     return DeliveryService.get(`/console/orders/search?`+queryString)
    },
    getOrders(params) {
        var queryString = Object.keys(params)
        .map(key => key + "=" + params[key])
        .join("&");
     return DeliveryService.get(`/console/orders?`+queryString)
    },
    getCommerceOrders(params) {
        var queryString = Object.keys(params)
        .map(key => key + "=" + params[key])
        .join("&");
     return DeliveryService.get(`/console/commerce/orders?`+queryString)
    },
    get(ref) {
        return DeliveryService.get(`/console/orders/` + ref)
    },
    addOrder(data) {
        return DeliveryService.post(`/orders`, data)
    },
    updateBasket(data) {
        return DeliveryService.post(`/console/orders/` + data.order_id + "/basket", data)
    },
    updateCustomField(data) {
        return DeliveryService.post(`/console/orders/` + data.order_id + "/update_custom", data)
    },
    updateStatus(orderId, data) {
        return DeliveryService.post(`/orders/` + orderId + `/update/status`, data)
    },
    updateFee(orderId, data) {
        return DeliveryService.post(`/orders/` + orderId + `/update/fee`, data)
    },
    updateDatetime(ref, data) {
        return DeliveryService.post(`/console/orders/` + ref + `/update/datetime`, data)
    },
    updateShop(ref, data) {
        return DeliveryService.post(`/console/orders/` + ref + `/update/shop`, data)
    },
    getPayment(ref) {
        return DeliveryService.get(`/console/orders/` + ref + `/payment`)
    },
    quotationDriver(orderId, data) {
        return DeliveryService.post(`/console/orders/` + orderId + `/driver-quotation`, data)
    },
    requestDriver(orderId, data) {
        return DeliveryService.post(`/console/orders/` + orderId + `/driver-request`, data)
    },
    cancelDriver(orderId) {
        return DeliveryService.post(`/console/orders/` + orderId + `/driver-cancel`, null)
    },
    getDriver(orderId) {
        return DeliveryService.get(`/console/orders/` + orderId + `/driver`)
    },
    getActions(ref) {
        return DeliveryService.get(`/console/orders/` + ref + `/actions`)
    },
    capturePayment(orderId) {
        return DeliveryService.post(`/orders/` + orderId + `/payment/capture`)
    },
    refundPayment(ref) {
        return DeliveryService.post(`/orders/` + orderId + `/payment/refund`)
    },
    getDrivers(ref) {
        return DeliveryService.get(`/console/orders/` + ref + `/list-driver`)
    },
    logistic(order_id) {
        return DeliveryService.post(`/console/orders/` + order_id + `/logistic`)
    }
    /*
    captureCard(orderId, data) {
        return DeliveryService.post(`/orders/` + orderId + `/update/status`, data)
    }
    */
}

export default Order